var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { SpanTag, InputTag, LabelTag } from '../../Utils/AtomicTag';
import Loading from '../Loading';
import Transition from '../../components/Transition';
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var checked = _this.state.checked;
            var newChecked = !checked;
            _this.setChecked(newChecked, e);
        };
        _this.handleClick = function (e) {
            var _a = _this.props, loading = _a.loading, onClick = _a.onClick;
            var checked = _this.state.checked;
            var cls = e.target.className;
            if (loading)
                return;
            if (typeof cls === 'string' && cls.includes('switch-o')) {
                e.stopPropagation();
                // @ts-ignore
                onClick(!checked, e);
            }
            else {
                // @ts-ignore
                onClick(!checked, e);
            }
        };
        var checked = false;
        if ('checked' in props) {
            checked = !!props.checked;
        }
        else {
            checked = !!props.defaultChecked;
        }
        _this.state = {
            checked: checked,
        };
        return _this;
    }
    Switch.getDerivedStateFromProps = function (props, state) {
        if ('checked' in props) {
            return __assign(__assign({}, state), { checked: props.checked });
        }
        return null;
    };
    Switch.prototype.setChecked = function (checked, e) {
        var _a = this.props, disabled = _a.disabled, onChange = _a.onChange;
        if (disabled) {
            return;
        }
        if (!('checked' in this.props)) {
            this.setState({
                checked: checked,
            });
        }
        onChange(checked, e);
    };
    Switch.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, loading = _a.loading, className = _a.className, style = _a.style, onChange = _a.onChange, activeText = _a.activeText, inactiveText = _a.inactiveText, width = _a.width, rest = __rest(_a, ["disabled", "loading", "className", "style", "onChange", "activeText", "inactiveText", "width"]);
        var checked = this.state.checked;
        var switchLabel = ['relative', 'inline-block', 'h-px-24', 'align-middle'];
        var switchO = ['inline', 'opacity-0'];
        var switchInner = [
            'absolute',
            'left-0',
            'inline-block',
            'w-full',
            'h-full',
            'border',
            'border-solid',
            'border-gray-500',
            'bg-gray-400',
            'rounded-xxl',
        ];
        var svgClass = ['w-px-16', 'h-px-16', 'absolute'];
        var textClass = [
            'absolute',
            'text-white',
            'leading-none',
            'ml-px-4',
            'top-0',
            'mt-px-4',
            'text-xs',
        ];
        var activeTextClass = __spread(textClass, ['left-0', 'ml-px-4']);
        var inactiveTextClass = __spread(textClass, ['right-0', 'mr-px-2']);
        var styleObj = __assign(__assign({}, style), { width: width + "px" });
        return (React.createElement(React.Fragment, null,
            React.createElement(LabelTag, __assign({ name: Switch.NAME, style: styleObj, atomics: switchLabel, autoPrefixedClassName: loading ? 'switch-is-loading' : 'switch-is-loading2', className: className + " " + (checked ? 'is-checked' : '') }, rest, { onClick: this.handleClick }),
                React.createElement(InputTag, { type: "checkbox", atomics: switchO, autoPrefixedClassName: "switch-o", checked: checked, disabled: disabled || loading, onChange: this.handleChange }),
                React.createElement(Transition, { in: checked, unmountOnExit: false, classNames: "click-animating", timeout: 500 },
                    React.createElement(SpanTag, { atomics: switchInner, autoPrefixedClassName: "switch-inner" },
                        activeText && checked && React.createElement(SpanTag, { atomics: activeTextClass }, activeText),
                        inactiveText && !checked && (React.createElement(SpanTag, { atomics: inactiveTextClass }, inactiveText)))),
                loading && React.createElement(Loading, { size: "small", className: svgClass.join(' ') }))));
    };
    Switch.defaultProps = defaultProps;
    Switch.NAME = 'switch';
    Switch.displayName = 'Switch';
    return Switch;
}(PureComponent));
export { Switch };
